import { jsx } from "@ecopages/jsx/jsx-runtime";
import { withDefaultAriaLabel } from "@/aria";
import { coalesceDefined } from "@/lib/coalesce-defined";
import { cx } from "@/lib/cx";
function initialsFrom(label) {
  const parts = label.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] ?? ""}${parts[1][0] ?? ""}`.toUpperCase();
}
export function RuiAvatar({
  src,
  alt = "",
  fallback,
  size = "md",
  class: className,
  children,
  role,
  aria,
  ...props
}) {
  const label = fallback ?? (alt ? initialsFrom(alt) : void 0);
  return /* @__PURE__ */jsx("span", {
    ...props,
    aria: withDefaultAriaLabel(aria, src ? void 0 : alt || fallback),
    class: cx("rui-avatar", `rui-avatar--${size}`, className),
    role: coalesceDefined(role, src ? void 0 : "img"),
    children: src ? /* @__PURE__ */jsx("img", {
      class: "rui-avatar__image",
      src,
      alt
    }) : /* @__PURE__ */jsx("span", {
      class: "rui-avatar__fallback",
      "aria-hidden": alt || fallback ? "true" : void 0,
      children: children ?? label ?? "?"
    })
  });
}